/**
 * @param {string | URL | undefined} url
 */
export function openInNewTab(url) {
  window.open(url, "_blank", "noopener,noreferrer")
}
